import { useState, useCallback } from "react";
import { useStore } from "../../../store";

import { PaymentIntent, StripeError } from "@stripe/stripe-js";

interface ConfirmPaymentIntentBaseResult {
  success: boolean;
}

interface SuccessResult extends ConfirmPaymentIntentBaseResult {
  success: true;
  paymentIntent: PaymentIntent;
}

interface FailureResult extends ConfirmPaymentIntentBaseResult {
  success: false;
  error: StripeError;
}

type ConfirmPaymentIntentResult = SuccessResult | FailureResult;

export const useConfirmPaymentIntent = () => {
  const { stripe } = useStore();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<StripeError>(null);

  const confirmPaymentIntent = useCallback(
    async (clientSecret: string): Promise<ConfirmPaymentIntentResult> => {
      setIsLoading(true);
      setError(null);
      try {
        const result = await stripe.confirmCardPayment(clientSecret);
        if (result.error) {
          setError(result.error);
          return { success: false, error: result.error };
        }
        if (result.paymentIntent.status === "succeeded")
          return { success: true, paymentIntent: result.paymentIntent };
      } catch (error) {
        return { success: false, error };
      } finally {
        setIsLoading(false);
      }
    },
    [stripe]
  );

  return { confirmPaymentIntent, isLoading, error };
};
